import { gql } from '@apollo/client';
import { DateTime, ObjectID, String, Url, YoutubeFile } from 'graphql/main/queries';

export interface FileModel {
  id?: ObjectID;
  fileId?: ObjectID;
  originalKey?: String;
  originalUrl?: String;
  type?: String;
  urls?: Url[];
  creator?: String;
  createdAt?: DateTime;
  updatedAt?: DateTime;
}

export type Upload = File;
export interface MutationOfFileType extends MutationOf {
  payload?: FileModel;
}
export interface MutationOfYoutubeType extends MutationOf {
  payload?: YoutubeFile;
}
export interface MutationOf {
  success?: Boolean;
  msg?: String;
}

export interface SingleUploadData {
  singleUpload?: MutationOfFileType;
}
export interface SingleUploadVariables {
  file: Upload;
}

export const SINGLE_UPLOAD = gql`
  mutation singleUpload($file: Upload!) {
    singleUpload(file: $file) {
      msg
      success
      payload {
        id
        originalUrl
        createdAt
        creator
        fileId
        type
        updatedAt
        urls {
          type
          url
        }
        name
        size
      }
    }
  }
`;
